<template>
  <div>
    <pro-d-grid-view :areas="assessment.areas"></pro-d-grid-view>
    <pro-d-rank-view :numbers="idsSortedByRank()"></pro-d-rank-view>

    <v-btn
      v-if="!isMember()"
      class="ma-4 js-updaters-toggle-button"
      small
      fab
      dark
      color="secondary"
      @click="showUpdater = !showUpdater"
    >
      <v-icon dark>mdi-pencil</v-icon>
    </v-btn>

    <v-sheet elevation="4" class="ma-4 pa-6" v-if="showUpdater">
      <pro-d-add :userId="userId"></pro-d-add>
    </v-sheet>
  </div>
</template>
<script>
import ProDGridView from "@/components/assessments/ProDGridView"
import ProDRankView from "@/components/assessments/ProDRankView"
import ProDAdd from "@/components/assessments/ProDAdd"
import titleMixin from "@/mixins/titleMixin"
import userMixin from "@/mixins/userMixin"
import eventMixin from "@/mixins/eventMixin"
import User from "@/lib/user"
import { mapGetters } from "vuex"
import { AssessmentsAPI } from "@/lib/api"

export default {
  mixins: [titleMixin, userMixin, eventMixin],
  components: { ProDGridView, ProDRankView, ProDAdd },
  data: function() {
    return {
      title: "Work Style",
      userId: this.$route.params.id,
      userType: User.getUserType(),
      assessment: { areas: [] },
      showUpdater: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id

      this.$store
        .dispatch("assessments/assessmentsByUserId", {
          userId: this.userId
        })
        .then(() => {
          this.assessment = this.getAssessmentByType("Pro-D") || { areas: [] }
        })
    }
    next()
  },
  created() {
    this.assessment = this.getAssessmentByType("Pro-D") || { areas: [] }

    // listener for add pro-d
    this.addListener(
      "pro_d_result:add",
      ({ userId, name, mission, competency, style, rank, visible }) => {
        AssessmentsAPI.addProD(
          userId,
          name,
          mission,
          competency,
          style,
          rank,
          visible
        ).then(() => {
          this.$store
            .dispatch("assessments/assessmentsByUserId", {
              userId: this.userId
            })
            .then(() => {
              this.assessment = this.getAssessmentByType("Pro-D")
            })
        })
      }
    )

    this.addListener("pro_d_result:visibility", ({ visible, userId }) => {
      AssessmentsAPI.updateProDVisibility(userId, visible).then(() => {
        this.$store
          .dispatch("assessments/assessmentsByUserId", {
            userId: this.userId
          })
          .then(() => {
            this.assessment = this.getAssessmentByType("Pro-D")
          })
      })
    })
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    },
    byRank(a, b) {
      if (a.rank < b.rank) {
        return -1
      }
      if (a.rank > b.rank) {
        return 1
      }
      return 0
    },
    idsSortedByRank() {
      let areas =
        this.assessment && this.assessment.areas ? this.assessment.areas : []
      let ranks = areas.map(el => {
        return {
          rank: parseInt(el.rank),
          id: parseInt(el.name.split("_")[0])
        }
      })
      return ranks.sort(this.byRank).map(el => el.id)
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>
